
import CheckWebpFeature from "./src/common/ggfx-client/module/webp-checker"


CheckWebpFeature()


